import { Action } from "redux";
import produce from "immer";
import { IMeterObject } from "./types";

export interface IMeterState {
  meters: IMeterObject[];
  monitoringOn: boolean;
  isFetching: boolean;
  fetchingError: boolean;
}

const initialState: IMeterState = {
  meters: [],
  monitoringOn: false,
  isFetching: false,
  fetchingError: false,
};

const FETCHING_METER_DATA = "METER/FETCHING_METER_DATA";
const FETCHING_METER_DATA_SUCCESSFUL = "METER/FETCHING_METER_DATA_SUCCESSFUL";
const FETCHING_DATA_ERROR = "METER/FETCHING_DATA_ERROR";
const TOGGLE_SINGLE_METER = "METER/TOGGLE_SINGLE_METER";
const TOGGLE_MONITORING_FOR_ALL_METERS =
  "METER/TOGGLE_MONITORING_FOR_ALL_METERS";

export interface IFetchingMeterAction {
  type: typeof FETCHING_METER_DATA;
}

export interface IFetchingMeterSuccessfulAction {
  type: typeof FETCHING_METER_DATA_SUCCESSFUL;
  payload: { meters: IMeterObject[] };
}

export interface IFetchingDataErrorAction {
  type: typeof FETCHING_DATA_ERROR;
}
export interface IToggleMonitoringForAllMetersAction {
  type: typeof TOGGLE_MONITORING_FOR_ALL_METERS;
  payload: { toggleMonitoring: boolean };
}
export interface IToggleSingleMeterAction {
  type: typeof TOGGLE_SINGLE_METER;
  payload: { meter: IMeterObject };
}

export const actionCreator = {
  fetchingMeterData: {
    type: FETCHING_METER_DATA,
  } as IFetchingMeterAction,
  fetchingMeterDataSuccess: (meters: IMeterObject[]) =>
    ({
      type: FETCHING_METER_DATA_SUCCESSFUL,
      payload: { meters },
    } as IFetchingMeterSuccessfulAction),
  toggleMonitoringForAllMeters: (toggleMonitoring: boolean) =>
    ({
      type: TOGGLE_MONITORING_FOR_ALL_METERS,
      payload: { toggleMonitoring },
    } as IToggleMonitoringForAllMetersAction),
  fetchingDataError: {
    type: FETCHING_DATA_ERROR,
  } as IFetchingDataErrorAction,
  toggleSingleMeter: (meter: IMeterObject) =>
    ({
      type: TOGGLE_SINGLE_METER,
      payload: { meter },
    } as IToggleSingleMeterAction),
};

export const meterReducer = (state = initialState, action: Action<string>) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCHING_METER_DATA:
        draft.isFetching = true;
        break;
      case FETCHING_METER_DATA_SUCCESSFUL:
        const fetchingMeterDataSuccessAction =
          action as IFetchingMeterSuccessfulAction;
        draft.meters = fetchingMeterDataSuccessAction.payload.meters;
        draft.isFetching = false;

        if (draft.meters.some((m) => m.Monitoring === true)) {
          draft.monitoringOn = true;
          break;
        }
        if (draft.meters.some((m) => m.Monitoring === false)) {
          draft.monitoringOn = false;
          break;
        }

        break;
      case TOGGLE_MONITORING_FOR_ALL_METERS:
        const toggleMonitoringAction =
          action as IToggleMonitoringForAllMetersAction;
        draft.monitoringOn = toggleMonitoringAction.payload.toggleMonitoring;
        draft.meters.forEach((m) => {
          m.Monitoring = toggleMonitoringAction.payload.toggleMonitoring;
        });
        draft.isFetching = false;
        break;
      case FETCHING_DATA_ERROR:
        draft.isFetching = false;
        draft.fetchingError = true;
        break;
      case TOGGLE_SINGLE_METER:
        const toggleSingleMeter = action as IToggleSingleMeterAction;
        const index = draft.meters.findIndex(
          (m) => m.PositionID === toggleSingleMeter.payload.meter.PositionID
        );
        draft.meters[index].Monitoring =
          toggleSingleMeter.payload.meter.Monitoring;
        if (draft.meters.some((m) => m.Monitoring === true)) {
          draft.monitoringOn = true;
          break;
        }
        if (draft.meters.some((m) => m.Monitoring === false)) {
          draft.monitoringOn = false;
          break;
        }
        break;
    }
  });
